








import { Vue, Component } from 'vue-property-decorator'
import PageTransition from '~/components/PageTransition.vue'

@Component({
    components: {
        PageTransition
    }
})
export default class Content extends Vue {}
